import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden bg-stone-100 min-h-[320px] lg:min-h-[520px]">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20art%20style%20illustration%2C%20dreamy%20fantasy%20scene%20with%20floating%20book%20pages%20and%20magical%20particles%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20ethereal%20atmosphere%2C%20clean%20composition%2C%20artistic%20and%20elegant%20mood%2C%20soft%20lighting%2C%20editorial%20quality&width=1200&height=800&seq=cta-left-visual&orientation=landscape"
          alt="韩漫屋无限畅读"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-100/0 to-stone-100/0"></div>
        <div className="absolute bottom-8 left-8">
          <p className="text-xs text-stone-600 font-medium uppercase tracking-wider">阅读体验</p>
          <p className="text-3xl md:text-5xl font-black font-[family-name:var(--font-heading)] text-stone-800 leading-none mt-2">
            无限畅读<br />高清画质
          </p>
        </div>
      </div>

      <div className="lg:w-1/2 bg-white flex items-center justify-center p-10 md:p-16 lg:p-20">
        <div className="max-w-md text-center lg:text-left">
          <h2 className="text-2xl md:text-3xl font-bold font-[family-name:var(--font-heading)] text-stone-800 leading-snug">
            随时随地<br />畅享韩漫世界
          </h2>
          <p className="mt-5 text-stone-500 text-sm leading-relaxed">
            韩漫屋支持手机、平板和电脑多端同步阅读。无论您身在何处，只需打开浏览器即可畅享海量韩国漫画。高清画质、流畅翻页、纯净无广告，为您打造极致的在线阅读体验。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 lg:justify-start justify-center">
            <Link
              to="/category/langman-aiqing"
              className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-stone-800 text-white rounded-full text-sm font-medium hover:bg-stone-700 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读 <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-8 py-3 border border-stone-300 text-stone-600 rounded-full text-sm font-medium hover:bg-stone-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}